var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10637",
    "data-name": "Group 10637",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2986",
    "data-name": "Rectangle 2986",
    width: 14,
    height: 14,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10636",
    "data-name": "Group 10636",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28435",
    "data-name": "Path 28435",
    d: "M7.046,14A1.752,1.752,0,0,1,5.3,12.25a.425.425,0,0,0-.7-.324,1.764,1.764,0,0,1-2.508.032,1.754,1.754,0,0,1,0-2.478A.4.4,0,0,0,2.2,9.028.387.387,0,0,0,1.846,8.8h-.1a1.75,1.75,0,0,1,0-3.5.424.424,0,0,0,.324-.7,1.774,1.774,0,0,1-.545-1.271,1.742,1.742,0,0,1,.513-1.237,1.8,1.8,0,0,1,2.477,0,.4.4,0,0,0,.451.107.618.618,0,0,1,.111-.036.386.386,0,0,0,.168-.316v-.1a1.75,1.75,0,0,1,3.5,0,.4.4,0,0,0,.231.4A.385.385,0,0,0,9.4,2.074,1.751,1.751,0,1,1,11.909,4.52a.4.4,0,0,0-.106.45.7.7,0,0,1,.036.113.384.384,0,0,0,.315.167h.1a1.75,1.75,0,0,1,0,3.5.4.4,0,0,0-.4.231l0,0a.381.381,0,0,0,.075.417,1.767,1.767,0,0,1,.544,1.269,1.74,1.74,0,0,1-.513,1.237,1.8,1.8,0,0,1-2.478,0,.394.394,0,0,0-.45-.106.383.383,0,0,0-.233.35v.1A1.752,1.752,0,0,1,7.046,14M4.877,10.656a1.516,1.516,0,0,1,.608.128,1.526,1.526,0,0,1,.978,1.4.6.6,0,0,0,.583.649.585.585,0,0,0,.583-.583v-.1a1.553,1.553,0,0,1,2.637-1.1.6.6,0,0,0,.866.038.583.583,0,0,0,0-.825,1.577,1.577,0,0,1-.35-1.741,1.552,1.552,0,0,1,1.412-.934A.6.6,0,0,0,12.833,7a.584.584,0,0,0-.583-.583h-.1a1.552,1.552,0,0,1-1.416-.936.565.565,0,0,1-.043-.155,1.54,1.54,0,0,1,.355-1.593.586.586,0,1,0-.787-.866,1.575,1.575,0,0,1-1.744.349,1.55,1.55,0,0,1-.932-1.411A.6.6,0,0,0,7,1.167a.584.584,0,0,0-.583.583v.1a1.553,1.553,0,0,1-.935,1.416.572.572,0,0,1-.156.044,1.546,1.546,0,0,1-1.593-.355.585.585,0,1,0-.866.786,1.579,1.579,0,0,1,.349,1.745,1.527,1.527,0,0,1-1.4.978.6.6,0,0,0-.649.583.584.584,0,0,0,.583.583h.1a1.554,1.554,0,0,1,1.1,2.637.6.6,0,0,0-.039.866.584.584,0,0,0,.825,0,1.623,1.623,0,0,1,1.136-.477M11.317,8.75h0ZM7,9.333A2.333,2.333,0,1,1,9.333,7,2.336,2.336,0,0,1,7,9.333m0-3.5A1.167,1.167,0,1,0,8.167,7,1.168,1.168,0,0,0,7,5.833",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/setting_icon.c4b9e9fb856bee7af31f5c58e10e99ec.svg";
export { ForwardRef as ReactComponent };